module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch00_part1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  }), _vm._v(" PART "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('strong', [_vm._v("What is an adult? A child blown up by age.")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—"), _c('strong', [_vm._v("Simone de Beauvoir,")]), _vm._v(" "), _c('em', [_vm._v("La Femme Rompue")])])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common3.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eb99f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_part1.vue
// module id = 90
// module chunks = 0